var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.688477,
    y: 0.0610352,
    width: 16.493,
    height: 18.8636,
    fill: "url(#pattern0_483_756)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_483_756",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_483_756",
    transform: "matrix(0.0114373 0 0 0.01 -0.0718661 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_483_756",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA6hJREFUeAHtnctuEzEUhocN7EBA7Cl7FtAVSLxBqznHk3VfAhaVEOL2BDwEF6lcFn0ClvAIXN4BFlSV2DepTmiqkVM8ySTjy/ivNKqdScfH/+ff9njSuCjwAwWgABSAAlAACkABKAAFoAAUgAJQAApAASgABaAAFAilwJYx24r5hWZ+VzIf5nRInaXut8bju6H0Py/3+u7uNc38STNPNPM082Oijfl4w5ir5wL5TAgMZcyPzCEsNEJVVd+DQDlzxkJAAMTTUVW992mOQsYMdFPOLnridUwpiV7CCU4gU8X83JtLZGYBIG4gJdEbb0BkWgsgLUCYDwEkoqm3NFoAARC3bXPu1uCQiNwhDRFAAATdlatLhkPgEDgEDonMBQACIBffa8qA5WodOIdpb3TPZTDLiqw7AxAAwbTXNVbCIXAIHAKHROYCAAGQDd8YEv3VzA/1zk6p6npLET3S/16L4z5ig/ElMagr5tpGrOr6nmL+47K/l3NEx6O6fmDHNyIadyk/eiDysVO7svO8Mua+Zj7qUvEN/c2RxDCPx/49Yv65ajnRA9HMn+2KNvMBoThhSIwS+/CAEP3a3tu73IRgpwNAaYVx25grypjfwwMiD/6JXtkQ7LxHKK0wJDaJeVUY8v4UuqzZTEo+F2xDsPO9D/T/GcDtODTz4y4wkgIyCzYkFA8wkgMSDIonGEkC8Q7FI4xkgXiD4hlG0kB6hxIARvJAeoMSCMYggGwcSkAYgwGyMSiBYQwKyNpQIoAxOCCdoUQCY5BAVoYSEYzBApGKaWOe2GtMdl4WJOWwX7fzcq3ZNT08Ck5mcbGLIMssSNri2/l1Fgo7xTz0/8JdB4pvGAJw0A6Zt9AuUELAyAbIrKJLLN3Pu6tQMLICsiyUkDCyA9IGJTSMLIFIpeW7DouiuDTvoiR99t2PwT94l8WgLhDso6yqLyXRvhya6Kt9PlQ+WyChBG8rF0AucE+baH2eBxAAWezP+2xxqV0bDoFD4BCXa+EQOAQOgUMicwGAAEhjlaiRlAHL1TpwLpMHVCmBxiwrsu7MLxBj3qbUWkPEqqrqdaOX7zcpz7ZDVDKlMr1uVyGblWBDF8d9GNHJzaq6068trKvLBlgptVjPsR5YcvWflY2vZAMszxVdeGIYW/mK6FuQTcEEuRSsmT+g++KpJjrRzAfBYDQ9KGOKMuZZrhtLaqKn3seMJgCkoQAUgAJQAApAASgABaAAFIACUAAKQAEoAAWgABSAAqceLB7Nc9BiPgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/dropDownArrow.d91e61c3227e5d48419f021a89402562.svg";
export { ForwardRef as ReactComponent };